// extracted by mini-css-extract-plugin
export default {"container":"menu-button_container__3kszi","icon":"menu-button_icon__1sU7L"};